export default {"src":"/_next/static/image/public/images/ic_default_doc.50ac205ba6e45c1e6d8e88490416ecaa.svg","height":50,"width":50};